import { render, staticRenderFns } from "./ModifyDobModal.vue?vue&type=template&id=467696b2&scoped=true&"
import script from "./ModifyDobModal.vue?vue&type=script&lang=js&"
export * from "./ModifyDobModal.vue?vue&type=script&lang=js&"
import style0 from "./ModifyDobModal.vue?vue&type=style&index=0&id=467696b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467696b2",
  null
  
)

export default component.exports